/**
 * @file    npsColors.ts
 * @scope   SHARED
 * @summary Canonical colours for the NPS bands (detractors / passives / promoters), shared by the
 *          NPS slider and its legend so both stay in sync.
 * @produces `NpsColorKey`, `NPS_COLORS`
 * @sideEffects None — constants only.
 */
export type NpsColorKey = 'detractors' | 'passives' | 'promoters';

export const NPS_COLORS: Record<NpsColorKey, string> = {
  detractors: 'rgb(245, 93, 128)',
  passives: 'rgb(254, 206, 62)',
  promoters: 'rgb(118, 212, 140)',
};
